import { render, staticRenderFns } from "./AssinaturaDocumento.vue?vue&type=template&id=be5a629c"
import script from "./AssinaturaDocumento.vue?vue&type=script&lang=js"
export * from "./AssinaturaDocumento.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaDocumento.vue?vue&type=style&index=0&id=be5a629c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports